import { makeObservable, observable, action } from 'mobx';
import { SingleValue } from 'src/components/DropdownWrapper/DropdownWrapper';
import config from 'src/config';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export interface SelectOptionType {
    key: string;
    name: string;
}

export const mobilePrefixes = config.mobilePrefixes
    .map((prefix) => {
        return {
            key: `${prefix.prefix}-${prefix.id}`,
            name: `${prefix.prefix} ${prefix.id}`,
        };
    })
    .sort((x, y) => (x.name > y.name ? 1 : -1));

export const mobilePrefixFromKey = (key: string): string => {
    return key.slice(0, key.lastIndexOf('-'));
};

export const mobileCountryFromKey = (key: string): string => {
    return key.slice(key.lastIndexOf('-') + 1, key.length);
};

export const countriesList = config.countries.map((c) => ({
    key: c.id,
    name: c.name,
}));

export function getPrefix(mobilePhonePrefix: string, mobilePhoneCountry: string): SelectOptionType | undefined {
    return mobilePrefixes.find((item) => item.key === `${mobilePhonePrefix}-${mobilePhoneCountry}`);
}

export function getCountryKey(country: string): SelectOptionType | undefined {
    return countriesList.find((item) => item.key === country);
}

export class CountryDropdownNewState {
    @observable public value: SingleValue<SelectOptionType> = null;
    public constructor(private readonly stateValue: FormInputState<string, string>) {
        makeObservable(this);

        const initialPrefix = mobilePrefixFromKey(this.stateValue.value);
        const initialCountry = mobileCountryFromKey(this.stateValue.value);
        const prefixValue = getPrefix(initialPrefix, initialCountry);
        this.value = prefixValue === undefined ? null : prefixValue;
    }

    @action public onChange = (event: SingleValue<SelectOptionType>): void => {
        this.value = event;
        if (event !== null && 'key' in event) {
            this.stateValue.setValue(event.key);
        }
    };
}
